import { Action } from '@ngrx/store';

export class PosRiskAction implements Action {

    public static getStress: string = '[Pos Risk] get_stress_';
    public static gettingStress: string = '[Pos Risk] getting_stress';
    public static getStressError: string = '[Pos Risk] get_stress_error';
    public static getStressSuccess: string = '[Pos Risk] get_stress_success';
    public static getDefaultStressSuccess: string = '[Pos Risk] get_default_stress_success';
    public static getStrategyStressSuccess: string = '[Pos Risk] get_strategy_stress_success';
    public static getDayTradeStressSuccess: string = '[Pos Risk] get_daytrade_stress_success';

    public static getStressArray: string = '[Pos Risk] getStressArray';
    public static gettingStressArray: string = '[Pos Risk] gettingStressArray';
    public static getStressArrayError: string = '[Pos Risk] getStressArrayError';
    public static getStressArraySuccess: string = '[Pos Risk] getStressArraySuccess';

    public static getClientCustodies: string = '[Pos Risk] getClientCustodies';
    public static getClientCustodiesError: string = '[Pos Risk] getClientCustodiesError';
    public static getClientCustodiesSuccess: string = '[Pos Risk] getClientCustodiesSuccess';

    public static getClientRiskModel: string = '[Pos Risk] getClientRiskModel';
    public static setClientRiskModel: string = '[Pos Risk] setClientRiskModel';
    public static getClientRiskModelError: string = '[Pos Risk] getClientRiskModelError';
    public static setClientRiskModelError: string = '[Pos Risk] setClientRiskModelError';
    public static getClientRiskModelSuccess: string = '[Pos Risk] getClientRiskModelSuccess';
    public static setClientRiskModelSuccess: string = '[Pos Risk] setClientRiskModelSuccess';

    public static setAccountPermission: string = '[Pos Risk] set_account_permission';
    public static setAccountPermissionError: string = '[Pos Risk] set_account_permission_error';
    public static setAccountPermissionSuccess: string = '[Pos Risk] set_account_permission_success';

    constructor(
        public type: string,
        public payload?: any,
    ) {}

}
